import { render, staticRenderFns } from "./cerrarHistoria.vue?vue&type=template&id=1d9080c6&scoped=true&"
import script from "./cerrarHistoria.vue?vue&type=script&lang=js&"
export * from "./cerrarHistoria.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9080c6",
  null
  
)

export default component.exports